import { UserSuperstarAbility } from '@wwe-portal/ui/features/roster';

export const extractSuperstarName = (name: string) => {
  const subString = name.match(/"(.*)"/)?.[1] ?? '';
  const mainString = name.replace(`"${subString}"`, '').trim();

  return { mainString, subString };
};

// Extract the local ability id from the ability id, remove the star level
export const extractLocalAbilityId = (
  ability: Pick<UserSuperstarAbility, 'name' | 'gemType'>
) => {
  return `${ability.name}_${ability.gemType}`;
};
